import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppSlice {
  offers: LoanApplicationOfferResponse;
}

const initialState: AppSlice = {
  offers: {
    id: "",
    loan_application_id: "",
    loan_amount: 0,
    term: 0,
    interest_rate: 0,
    opening_fee: 0,
    monthly_amount: 0,
    days_validity: 0,
    accept: false,
    declined: false,
    active: false,
    financial_company: {
      code: "",
      description: "",
      logo: "",
      name: "",
      company_id: null,
      company: null,
      is_partner: false,
    },
    financial_company_id: "",
    details: null,
  },
};

export const marketPlaceSlice = createSlice({
  name: "marketPalce",
  initialState,
  reducers: {
    setSelectedOffer: (state, action: PayloadAction<LoanApplicationOfferResponse>) => {
      state.offers = action.payload;
    },
  },
});

export const { setSelectedOffer } = marketPlaceSlice.actions;

export default marketPlaceSlice.reducer;
